/**
 * Route-facing page exports for App.tsx (Agent 5).
 * Re-exports real pages so routes work without changing App.tsx import path.
 */
import Login from './Login';
import AuthCallback from './AuthCallback';
import Demo from './Demo';
import Home from './Home';
import Find from './Find';
import Remove from './Remove';
import Monitor from './Monitor';
import Family from './Family';
import Account from './Account';
import Lexbase from './Lexbase';

/* Auth + Home (Agent 6) */
export function LoginPage() {
  return <Login />;
}
export function AuthCallbackPage() {
  return <AuthCallback />;
}
export function DemoPage() {
  return <Demo />;
}
export function HomePage() {
  return <Home />;
}

/* Pipeline (Agent 7) */
export function FindPage() {
  return <Find />;
}
export function RemovePage() {
  return <Remove />;
}
export function MonitorPage() {
  return <Monitor />;
}
export function FamilyPage() {
  return <Family />;
}
export function AccountPage() {
  return <Account />;
}
export function LexbasePage() {
  return <Lexbase />;
}
